import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import mnpuser from '../../assets/images/mnpuser.png'
import Session from "../../utils/sessionStorage";
import WelcomeModal from '../WelcomeModal';
import Prompt from '../Prompt';

const MNPCard = () => {
    const navigate = useNavigate();
    const result = Session.get("_user_");
    const userData = result ? JSON.parse(result) : "";
    const [isWelcomeModalShows, setIsWelcomeModalShows] = useState(false);
    const [isPromptModalShows, setIsPromptModalShows] = useState(false);
    const [nextRoute, setNextRoute] = useState("");
    // const handleClick = () => {
    //     // console.log("fdgfghjl")
    //     navigate('/mnp');
    // }

    const handleClick = () => {
        if (userData?.customerType === "StdCDD" || userData?.customerType === "FullCDD") {
            setIsWelcomeModalShows(true);
            setNextRoute("/mnp");
        } else {
            setIsPromptModalShows(true);
        }
    };

    const handleCloseWelcomeModal = () => {
        setIsWelcomeModalShows(false);
    };

    const handleProceed = () => {
        setIsWelcomeModalShows(false);
        if (nextRoute) {
            navigate(nextRoute);
        }
    };

    return (
        <div>
            <div className="mt-8 relative px-4">
                <div
                    className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-primary to-[#2e319166]"
                >
                    <div
                        className="w-[65%] h-[95%] absolute -right-12 -top-8 bg-[rgba(252,226,253,0.28)] rounded-full"
                    ></div>

                    <div>
                        <div className="flex flex-col items-start max-w-[219px] m-[30px] z-10 ">
                            <h1 className="text-white font-semibold text-[17px]">
                                Mobile Number <br />
                                Portability (MNP)
                            </h1>
                            <p className="text-[13px] text-[#FFFFFFCC] mt-1 z-50">
                                Switch to a new network without changing your number - quick,
                                simple, and hassle-free.
                            </p>

                            <div className="bg-white py-2 px-8 mt-6 rounded-full z-50" onClick={handleClick}>
                                <div className="text-primary text-[13px]">Switch Now</div>
                            </div>
                        </div>

                        <div className="absolute bottom-0 right-0 z-20">
                            <img src={mnpuser} alt="user" />
                        </div>
                    </div>
                </div>
            </div>
            <WelcomeModal
                isOpen={isWelcomeModalShows}
                onClose={handleCloseWelcomeModal}
                onProceed={handleProceed}
                message="Please make sure you have S4S blank sim before proceed"
                cancelText="No"
                proceedText="Proceed"
            />
            {isPromptModalShows && (
                <Prompt call="onLink" close={() => setIsPromptModalShows(false)} />
            )}
        </div>
    )
}

export default MNPCard
